import Model from "../Model";
import tw from "tailwind-styled-components";
import { SideCancelBtn, DeleteBtn } from "../Styles/InputStyles";

const DeleteNoteModal = ({
    setIsDeleteNoteModalOpen,
    selectedData,
    deleteNoteLoading,
    deleteNoteMutate,
}) => {

    const handleDeleteSubmit = () => {
        deleteNoteMutate({
            noteId: selectedData?.id
        });
    };

    return (
        <Model
            width="w-full max-w-md"
            setOpenModel={setIsDeleteNoteModalOpen}
            title="Confirm Delete"
        >
            <WarningText>
                This action will permanently delete this note. This cannot be undone.
            </WarningText>

            <div className="w-full flex justify-between space-x-6 my-4 mt-8">
                <SideCancelBtn
                    type="button"
                    onClick={() => setIsDeleteNoteModalOpen(false)}
                >
                    Cancel
                </SideCancelBtn>
                <DeleteBtn
                    onClick={handleDeleteSubmit}
                    disabled={deleteNoteLoading}
                    className="border border-rose-500 bg-white text-rose-500 hover:bg-rose-500 hover:text-white"
                >
                    {deleteNoteLoading ? "Loading..." : "Delete Note"}
                </DeleteBtn>
            </div>
        </Model>
    );
};

const WarningText = tw.p`text-gray-500 text-base mb-4`;

export default DeleteNoteModal;
